<script>
export default {
    data() {
        return {
            isLoading: false,
            apiKeysValid: false,
            dataKeysValid: false,
            integrationKeysValid: false,
            validationPerformed: false,
            errors: {},
        };
    },
    computed: {
        canBeSaved() {
            return this.validationPerformed && this.apiKeysValid && this.dataKeysValid && this.integrationKeysValid;
        },
        apiKeysState() {
            if (!this.validationPerformed) {
                return "";
            }

            return this.apiKeysValid ? "success" : "fail";
        },
        dataKeysState() {
            if (!this.validationPerformed) {
                return "";
            }

            return this.dataKeysValid ? "success" : "fail";
        },
        hasErrors() {
            return Object.keys(this.errors).length > 0;
        },
    },
    methods: {
        submitForm() {
            if (this.canBeSaved) {
                this.$refs.form.submit();
                return;
            }

            this.performValidation(() => this.$refs.form.submit());
        },
        formChanged() {
            this.validationPerformed = false;
        },
        performValidation(successCallback) {
            const credentialsFields = [
                "url",
                "client_id",
                "client_secret",
                "data_client_id",
                "data_client_secret",
            ];
            this.isLoading = true;
            this.validationPerformed = false;
            this.errors = {};

            const formData = new FormData(this.$refs.form);
            const requestData = new FormData();
            requestData.append("connection_type_id", formData.get("connection_type_id"));

            formData.entries().forEach((item) => {
                if (credentialsFields.includes(item[0])) {
                    requestData.append(`credentials[${item[0]}]`, item[1]);
                }

                if (item[0].startsWith("credentials[")) {
                    requestData.append(item[0], item[1]);
                }
            })

            axios.post(route("connections.validate-credentials"), requestData).then(({ data }) => {
                this.apiKeysValid = data.apiKeysValid;
                this.dataKeysValid = data.dataKeysValid;
                this.integrationKeysValid = data.integrationKeysValid;
                this.errors = data.errors;
                this.validationPerformed = true;

                if (successCallback && this.canBeSaved) {
                    successCallback();
                }
            }).catch((error) => {
                this.apiKeysValid = false;
                this.dataKeysValid = false;
                this.integrationKeysValid = false;
                this.validationPerformed = true;
                this.errors = [error.message];
                console.error(error);
            }).finally(() => this.isLoading = false);
        },
    },
};
</script>

<style scoped lang="scss">
.container.form-wrapper {
    position: relative;
}
</style>
